import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from "@angular/material/dialog";
import { Appointment } from "../../landing/models";
import { MessagingService } from "../../services/messaging.service";
import { MessagingConstants } from "../../models/MessagingConstants";
import { CaseFormsService } from "../../modules/case-forms/case-forms.service";
import { PatientCaseWorkItemFormDataModel } from "../../models/forms/data/patient-case-work-item-form-data.model";
import { PatientCheckinUploadDialogComponent } from "../patient-checkin-upload-dialog/patient-checkin-upload-dialog.component";
import { SchedulingService } from "../../modules/scheduling/scheduling.service";
import { AppointmentDocumentDataModel } from "../../models/appointments/appointment-document-data.model";
import { DocumentDisplayDialogComponent } from "../document-display-dialog/document-display-dialog.component";
import { DocumentDataModel } from "../../models/document/document-data.model";
import { FileManagerService } from "../../modules/file-manager/file-manager.service";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../modules/auth/services/authentication.service";

@Component({
  selector: "app-patient-checkin-dialog",
  templateUrl: "./patient-checkin-dialog.component.html",
  styleUrls: ["./patient-checkin-dialog.component.scss"],
})
export class PatientCheckinDialogComponent implements OnInit {
  patientForms: PatientCaseWorkItemFormDataModel[];
  unsignedForms: PatientCaseWorkItemFormDataModel[] = [];

  isMarkPatientAsCheckedIn = false;
  uploadedItems: AppointmentDocumentDataModel[] = [];
  loginCode: string = "";
  displayedColumns: string[] = ['date', 'description'];

  constructor(
    private dialogRef: MatDialogRef<PatientCheckinDialogComponent>,
    private scheduleService: SchedulingService,
    private messagingService: MessagingService,
    private caseFormsService: CaseFormsService,
    private dialog: MatDialog,
    private fileManagerService: FileManagerService,
    private router: Router,
    private authenticationService: AuthenticationService,
    @Inject(MAT_DIALOG_DATA) public data: Appointment
  ) {}

  ngOnInit(): void {
    this.caseFormsService.getPatientRepoForms(this.data.PatientId).subscribe((res) => {
      if (res) {
        console.log("Patient Forms:", res); // For debugging
        this.patientForms = res;
  
        // Sort the forms if necessary
        this.unsignedForms = res;
  
        // Log the content of unsignedForms for debugging
        console.log("unsignedForms:", this.unsignedForms);
  
        // If there are pending forms, request the login code
        if (this.unsignedForms.length > 0) {
          this.authenticationService.getLoginCodeForPatient(this.data.PatientId).subscribe((res1) => {
            this.loginCode = res1['LoginCode'];
            console.log("Login Code:", this.loginCode); // For debugging
          });
        }
  
        // Call the method to get associated documents
        this.getDocuments();
      }else {
        console.warn("No unsigned forms found.");
      }
    },
    (error) => {
      console.error("Error fetching unsigned forms:", error);

    });
  }
  
  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    if (this.isMarkPatientAsCheckedIn) {
      this.checkUserIn();
      //this.router.navigateByUrl('landing/case-view').then(() => {
      this.messagingService.sendParentMessage(
        MessagingConstants.PATIENT_CHANGED,
        {
          PatientID: this.data.PatientId,
          PatientName: this.data.PatientName,
          Process: MessagingConstants.RELOAD_SCHEDULE_APPOINTMENTS,
          clearCurrentQuery: false,
        }
      );
      //});
    }
    this.dialogRef.close(true);
  }

  openPatient() {
    //this.router.navigateByUrl('landing/case-view').then(() => {
    this.messagingService.sendParentMessage(
      MessagingConstants.PATIENT_CHANGED,
      {
        PatientID: this.data.PatientId,
        PatientName: this.data.PatientName,
        clearCurrentQuery: false,
      }
    );
    //});
    if (this.isMarkPatientAsCheckedIn) {
      this.checkUserIn();
    }
  }

  checkUserIn() {
    this.scheduleService
      .checkPatientIn(this.data.AppointmentId)
      .subscribe((res) => {});
  }

  onOpenUploadAppointmentDocsDialog() {
    const config = new MatDialogConfig();
    config.panelClass = "dialog";
    config.data = this.data;
    this.dialog
      .open(PatientCheckinUploadDialogComponent, config)
      .afterClosed()
      .subscribe((res) => {
        this.getDocuments();
      });
  }

  getDocuments() {
    this.scheduleService
      .getDocuments(this.data.AppointmentId)
      .subscribe((res) => {
        this.uploadedItems = res;
      });
  }

  getDate(xauditCreatedOn: Date) {
    return new Date(xauditCreatedOn).toDateString();
  }

  openDoc(item: AppointmentDocumentDataModel) {
    const config = new MatDialogConfig();
    config.panelClass = "dialog";
    if (item.file) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        config.data = event.target.result;
        this.dialog.open(DocumentDisplayDialogComponent, config);
      };
      reader.readAsDataURL(item.file);
    } else {
      const docModel = new DocumentDataModel();
      docModel.PatientId = item.PatientId;
      docModel.DocumentID = item.DocumentID;
      const idx = item.OriginalFileName.lastIndexOf(".");
      const extension = item.OriginalFileName.substring(
        idx + 1,
        item.OriginalFileName.length
      );
      docModel.DocumentFileName = item.DocumentID + "." + extension;
      config.data =
        this.fileManagerService.getDocumentUrlFromDocument(docModel);
      this.dialog.open(DocumentDisplayDialogComponent, config);
    }
  }

  getQRCode() {
    return `https://atesttdox-p.tdox.dental/patientportal/${this.loginCode}`;
  }
}
